import StaticPage from "@/pages/StaticPage";
export default function Historia() { return <StaticPage slug="historia" />; }
